import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENT_BUS } from 'vee-validate/dist/types/localeChanged';

@Component
export default class AbstractSelect extends Vue {
  @Prop({ type: [String, Number, Boolean, Array, Object], default: null }) readonly value:
    | string
    | number
    | boolean
    | number[]
    | object;

  @Prop({ type: String, default: 'text' }) readonly selectLabel: string;
  @Prop({ type: String, default: 'value' }) readonly selectValue: string;
  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly template: string;
  @Prop(String) readonly orderBy: string;
  @Prop(String) readonly orderDirection: string;
  @Prop({ type: Boolean, default: false }) readonly selectMultiple: boolean;
  @Prop({ type: Boolean, default: true }) readonly selectClearable: boolean;
  @Prop({ type: Boolean, default: true }) readonly selectSearchable: boolean;
  @Prop({ type: Boolean, default: true }) readonly selectFilterable: boolean;
  @Prop({ type: Boolean, default: false }) readonly selectShowLength: boolean;
  @Prop({ type: Boolean, default: true }) readonly selectShowSelectedOptions: boolean;
  @Prop(Object) readonly eventsConfig: any;
  @Prop(String) readonly selectForeignKey: string;
  @Prop({ type: Boolean, default: false }) readonly taggable: boolean;
  @Prop({ type: Boolean, default: false }) readonly pushTags: boolean;
  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  get model(): any {
    return this.value;
  }
  set model(val: any) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  hasNextPage() {
    return false;
  }
}
